window.BoletoEstornoMoipPage={
    watch: {
        required($refField){
            let $refSpan=BoletoEstornoMoipPage.getFieldSpan($refField);
            if (!FormGenericValidator.required($refField.val())) {
                BSForm.error($refField, $refSpan, "Este campo deve ser preenchido");
                return false;
            }
            else{
                BSForm.success($refField,$refSpan);
                return true;
            }
        },
        form_send: (fields) => {
            let self=BoletoEstornoMoipPage,
                button=$('#btnEnviar,#btnEnviarMobile');

            BSButton.loading(button);

            if(
                self.watch.required(fields.moip_account)
            ){
                $("#formEstornarBoletoMoip").unbind("submit",self.formHandler);
                $('#formEstornarBoletoMoip').submit();
            }
            else{
                BSButton.dismiss(button);
            }
        }
    },
    formHandler: null,
    getFieldSpan($field){
        return $field.parents(".form-group").first().find("span.help-block")
    },
    events(fields){

        $.each(fields,(field_name,field) => {
              field.change(() => {
                  this.watch.required(field);
              });
          });

        this.formHandler=(e) => {
            e.preventDefault();
            this.watch.form_send(fields);
        };
        $("#formEstornarBoletoMoip").submit(this.formHandler);
    },
    load(){
        let $form=document.querySelector('#formEstornarBoletoMoip');
        if($form) {
            let fields = {
                moip_account: $('[name=moip_account]', $form),
            };
            BoletoEstornoMoipPage.events(fields);

        }
    }
};
BoletoEstornoMoipPage.load();